import { render, staticRenderFns } from "./CommonContent.vue?vue&type=template&id=2f63b4a7"
import script from "./CommonContent.vue?vue&type=script&lang=js"
export * from "./CommonContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.16_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports